import {
  PRESUPUESTADOR_CLIENTE_SIRENA_BEGIN,
  PRESUPUESTADOR_CLIENTE_SIRENA_SUCCESS,
  PRESUPUESTADOR_CLIENTE_SIRENA_FAILURE,
  PRESUPUESTADOR_CLIENTE_SIRENA_DISMISS_ERROR,
} from './constants';
import { BFFAgent } from '../../../common/BFFAgent'

export function clienteSirena(args = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: PRESUPUESTADOR_CLIENTE_SIRENA_BEGIN,
    });

    const {presupuestador} = getState()

    const promise = async () => {
      try {
        const res = await BFFAgent.Sirena.clienteSirena(args)
        let phoneNumber = null
          // Quito el +549 del numero.
          if(res.data.phones?.[0]){
            const phoneN = res.data.phones[0].toString()
            let numbersP = phoneN.split("")
            let string = ""
            numbersP.forEach(n=>{
              if(n !== "+"){
                string = string + n
              }
            })
            phoneNumber = string
            numbersP = phoneNumber.split("")
            if(numbersP.length === 13){
              if(
                numbersP[0] === "5" &&
                numbersP[1] === "4" &&
                numbersP[2] === "9"
              ){
                string = ""
                numbersP.forEach((num, i)=>{
                  if(i > 2){
                    string = string + num
                  }
                })
                phoneNumber = string
              }
            }
          }
          dispatch({
            type: PRESUPUESTADOR_CLIENTE_SIRENA_SUCCESS,
            client_lead_original: res.data,
            data:{
              cliente: {
                id_cliente: '',
                nombre: res.data.firstName,
                apellido: res.data.lastName,
                email: res.data.emails?.[0],
                telefono: phoneNumber || null,
                tipoDoc: '',
                documento: '',
              },
              client_id_lead: args,
            }
          });
          return res;
      } catch (err) {
        dispatch({
          type: PRESUPUESTADOR_CLIENTE_SIRENA_FAILURE,
          data: { error: err },
          client_id_lead: err.response.status === 404 ? null : presupuestador.client_id_lead
        });
        throw err;
      }
    };

    return promise();
  };
}

export function dismissClienteSirenaError() {
  return {
    type: PRESUPUESTADOR_CLIENTE_SIRENA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_CLIENTE_SIRENA_BEGIN:
      return {
        ...state,
        client_lead_original: null,
        clienteSirenaPending: true,
        clienteSirenaError: null,
      };

    case PRESUPUESTADOR_CLIENTE_SIRENA_SUCCESS:
      return {
        ...state,
        ...action.data,
        clienteSirenaPending: false,
        clienteSirenaError: null,
      };

    case PRESUPUESTADOR_CLIENTE_SIRENA_FAILURE:
      return {
        ...state,
        client_lead_original: null,
        clienteSirenaPending: false,
        clienteSirenaError: action.data.error,
        client_id_lead: action.client_id_lead
      };

    case PRESUPUESTADOR_CLIENTE_SIRENA_DISMISS_ERROR:
      return {
        ...state,
        clienteSirenaError: null,
      };

    default:
      return state;
  }
}
